import { translations } from 'locales/i18n';
import * as yup from 'yup';

export const groupingValidationSchema = t =>
  yup.object().shape({
    name: yup
      .string()
      .required(t(translations.validation.required()))
      .label(t(translations.pages.groupings.modal.groupingName())),
    description: yup.string().nullable().label(t(translations.pages.groupings.modal.description()))
  });
